import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/last-index-of";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
/**
 * The file name a URL points at: the last path segment, decoded, with any query string or hash
 * dropped. `"download"` when the path has no segment (a bare origin or a trailing slash), so a
 * caller always has a usable name.
 */
export function fileNameFromUrl(url) {
  var pathname;
  try {
    pathname = new _URL(url, window.location.origin).pathname;
  } catch (_unused) {
    return "download";
  }
  var segment = pathname.substring(_lastIndexOfInstanceProperty(pathname).call(pathname, "/") + 1);
  if (!segment) return "download";
  try {
    return decodeURIComponent(segment);
  } catch (_unused2) {
    return segment;
  }
}

/** Whether a file URL names a PDF; signed-URL query strings don't count. */
export function isPdfUrl(url) {
  var _context;
  return _endsWithInstanceProperty(_context = fileNameFromUrl(url).toLowerCase()).call(_context, ".pdf");
}